import { render } from "./AgregarProveedor.vue?vue&type=template&id=122481c2&scoped=true"
import script from "./AgregarProveedor.vue?vue&type=script&lang=js"
export * from "./AgregarProveedor.vue?vue&type=script&lang=js"

import "./AgregarProveedor.vue?vue&type=style&index=0&id=122481c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122481c2"]])

export default __exports__